import type { FC } from 'react';

import { Typography } from '@mui/material';

import { CardItemStyled, CardStyleWrapper, IconWrapper } from './CardStub.style';

export type StubCardItemModel = {
  icon: any;
  title: string;
  description: string;
  callback: () => void;
};

type CardStubProps = {
  cardsData: StubCardItemModel[];
};

export const CardStub: FC<CardStubProps> = ({ cardsData }) => {
  const cards = cardsData.map((item, index) => (
    <CardItemStyled key={index} onClick={item.callback}>
      <IconWrapper>
        <item.icon />
      </IconWrapper>
      <Typography variant="s2" textAlign="center">
        {item.title}
      </Typography>
      <Typography
        variant="t12r"
        textAlign="center"
        sx={(theme) => ({
          color: theme.palette.case.neutral.n600,
        })}
      >
        {item.description}
      </Typography>
    </CardItemStyled>
  ));

  return <CardStyleWrapper>{cards}</CardStyleWrapper>;
};
